export default __webpack_public_path__ + "static/media/dollor-file-primary.2765a25a.svg";